export const toc = {
  life: '生活',
  work: '工作'
}

export const tocArray = [
  {
    id: 'life',
    text: '生活'
  },
  {
    id: 'work',
    text: '工作'
  }
]



// WEBPACK FOOTER //
// ./src/constants/gaConstants.js